__turbopack_context__.v({
  "border": "header-module-scss-module__CMpgVq__border",
  "cart_icon": "header-module-scss-module__CMpgVq__cart_icon",
  "cart_link": "header-module-scss-module__CMpgVq__cart_link",
  "cta_button": "header-module-scss-module__CMpgVq__cta_button",
  "ellipsis": "header-module-scss-module__CMpgVq__ellipsis",
  "hamberger_btn": "header-module-scss-module__CMpgVq__hamberger_btn",
  "headerSectionWrapper": "header-module-scss-module__CMpgVq__headerSectionWrapper",
  "header_space": "header-module-scss-module__CMpgVq__header_space",
  "heading_text": "header-module-scss-module__CMpgVq__heading_text",
  "headsection": "header-module-scss-module__CMpgVq__headsection",
  "headsection_logo_center": "header-module-scss-module__CMpgVq__headsection_logo_center",
  "headsection_logo_left": "header-module-scss-module__CMpgVq__headsection_logo_left",
  "headsection_logo_right": "header-module-scss-module__CMpgVq__headsection_logo_right",
  "login__section": "header-module-scss-module__CMpgVq__login__section",
  "login_menu_list": "header-module-scss-module__CMpgVq__login_menu_list",
  "logosection": "header-module-scss-module__CMpgVq__logosection",
  "logosection_center": "header-module-scss-module__CMpgVq__logosection_center",
  "logout": "header-module-scss-module__CMpgVq__logout",
  "marquee": "header-module-scss-module__CMpgVq__marquee",
  "marquee_container_bottom": "header-module-scss-module__CMpgVq__marquee_container_bottom",
  "marquee_container_top": "header-module-scss-module__CMpgVq__marquee_container_top",
  "marquee_content": "header-module-scss-module__CMpgVq__marquee_content",
  "menu_link": "header-module-scss-module__CMpgVq__menu_link",
  "menu_list": "header-module-scss-module__CMpgVq__menu_list",
  "middle_section": "header-module-scss-module__CMpgVq__middle_section",
  "middle_section_left": "header-module-scss-module__CMpgVq__middle_section_left",
  "no_marquee_content": "header-module-scss-module__CMpgVq__no_marquee_content",
  "primary__btn": "header-module-scss-module__CMpgVq__primary__btn",
  "promo_banner": "header-module-scss-module__CMpgVq__promo_banner",
  "sign_in": "header-module-scss-module__CMpgVq__sign_in",
  "sign_in_mobile_only": "header-module-scss-module__CMpgVq__sign_in_mobile_only",
  "signin_section": "header-module-scss-module__CMpgVq__signin_section",
  "sub_header": "header-module-scss-module__CMpgVq__sub_header",
  "user_display_name": "header-module-scss-module__CMpgVq__user_display_name",
  "vendor_logo_section": "header-module-scss-module__CMpgVq__vendor_logo_section",
});
